import { useEmailsQuotaQuery } from '../features/insights/useEmailsQuotaQuery';

export const EmailsQuotaPrefetch = () => {
  useEmailsQuotaQuery();
  return null;
};
